import { a as _inherits, b as _createClass, c as _classCallCheck, d as _callSuper } from './_rollupPluginBabelHelpers-047e4aae.js';
import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import 'react-dom';
import { _ as _slicedToArray, c as _extends, a as _objectSpread2 } from './_rollupPluginBabelHelpers-b9ad31fa-7ae21c08.js';
import 'styled-components';
import { s as styleInject } from './withTooltip-92e0dfed.js';
import '@styled-system/space';
import '@styled-system/color';
import '@styled-system/border';
import '@styled-system/variant';
import '@styled-system/typography';
import { I as Icon } from './index-28a062d6-3659b895.js';
import './index-155df85b-a520c7f0.js';
import './generic-7099c3ed-1383f6f8.js';
import { B as Button } from './button-fb2021fd.js';
import './text-5e5c8ea1.js';
import '@styled-system/layout';
import '@styled-system/flexbox';
import '@styled-system/position';
import '@styled-system/shadow';
import './box-e581bc98.js';
import { T as Text } from './index-5dfda37f-a2c0763c.js';
import { L as Loader$1 } from './loader-4d85b9a1.js';
import { A as Activify } from './activify-bf855d3e.js';
import Bole from './bole.js';
import { s as styleInject$1 } from './style-inject.es-1f59c1d0.js';

var css_248z = ".Loader_loaderWrapper__uY_pG {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  max-height: 100vh;\n  top: 0;\n  left: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: rgba(255, 255, 255, 0.8);\n  transition: 0.5s ease-out;\n  opacity: 0; }\n  .Loader_loaderWrapper__uY_pG > div {\n    transition: 0.5s ease-out;\n    transform: translateY(30px);\n    opacity: 0; }\n  .Loader_loaderWrapper__uY_pG.Loader_active__hYIP2 {\n    opacity: 1; }\n    .Loader_loaderWrapper__uY_pG.Loader_active__hYIP2 > div {\n      transform: translateY(0px);\n      opacity: 1; }\n";
var styles = {"loaderWrapper":"Loader_loaderWrapper__uY_pG","active":"Loader_active__hYIP2"};
styleInject(css_248z);

var Loading = Activify()(function (_ref) {
  var active = _ref.active,
    _ref$zIndex = _ref.zIndex,
    zIndex = _ref$zIndex === void 0 ? 1000000000 : _ref$zIndex,
    _ref$customStyles = _ref.customStyles,
    customStyles = _ref$customStyles === void 0 ? {} : _ref$customStyles;
  var activeClassName = active ? styles.active : "";
  return /*#__PURE__*/React.createElement("div", {
    style: _objectSpread2({
      zIndex: zIndex
    }, customStyles),
    className: "".concat(styles.loaderWrapper, " ").concat(activeClassName)
  }, /*#__PURE__*/React.createElement(Loader$1, null));
});
var Loader = function Loader(_ref2) {
  var customStyles = _ref2.customStyles,
    zIndex = _ref2.zIndex;
  return function (WrappedComponent) {
    return function (props) {
      var _useState = useState(false),
        _useState2 = _slicedToArray(_useState, 2),
        active = _useState2[0],
        setActive = _useState2[1];
      var activateLoader = useCallback(function () {
        setActive(true);
      }, []);
      var deactivateLoader = useCallback(function (e) {
        if (e) {
          e.preventDefault && e.preventDefault();
          e.stopPropagation && e.stopPropagation();
        }
        setActive(false);
      }, []);

      // TODO: Inconsitent terminology, We are not actually wrapping a component.
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(WrappedComponent
      // eslint-disable-next-line react/jsx-props-no-spreading
      , _extends({}, props, {
        loaderActive: active,
        activateLoader: activateLoader,
        deactivateLoader: deactivateLoader
      })), /*#__PURE__*/React.createElement(Loading, {
        active: active,
        zIndex: zIndex,
        customStyles: customStyles
      }));
    };
  };
};

var css_248z$1 = ".ErrorCatcher_errorCatcher__3GgnN {\n  background-image: url(\"https://s3-ap-southeast-1.amazonaws.com/haptikappimg/content/sdk-background.png\");\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100vw;\n  height: 100vh; }\n  .ErrorCatcher_errorCatcherCard__dIXKN {\n    max-width: 600px;\n    width: 100%;\n    border: 1px solid #EEE;\n    border-radius: 8px;\n    background-color: #fff;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 32px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05); }\n    .ErrorCatcher_errorCatcherCardIcon__GaRM7 {\n      width: 64px;\n      height: 64px;\n      margin-bottom: 8px; }\n    .ErrorCatcher_errorCatcherCardTitle__2tv2G {\n      font-size: 24px;\n      font-weight: 600;\n      color: #333;\n      margin-bottom: 4px; }\n    .ErrorCatcher_errorCatcherCardSubtitle__3Sf55 {\n      margin-bottom: 16px;\n      text-align: center; }\n    .ErrorCatcher_errorCatcherCardForm__387yX {\n      width: 100%;\n      margin-bottom: 8px; }\n    .ErrorCatcher_errorCatcherCardFormInput__3f8he {\n      width: 100%;\n      margin-bottom: 0; }\n";
var styles$1 = {"errorCatcher":"ErrorCatcher_errorCatcher__3GgnN","errorCatcherCard":"ErrorCatcher_errorCatcherCard__dIXKN","errorCatcherCardIcon":"ErrorCatcher_errorCatcherCardIcon__GaRM7","errorCatcherCardTitle":"ErrorCatcher_errorCatcherCardTitle__2tv2G","errorCatcherCardSubtitle":"ErrorCatcher_errorCatcherCardSubtitle__3Sf55","errorCatcherCardForm":"ErrorCatcher_errorCatcherCardForm__387yX","errorCatcherCardFormInput":"ErrorCatcher_errorCatcherCardFormInput__3f8he"};
styleInject$1(css_248z$1);

var ErrorCatcher = /*#__PURE__*/function (_React$Component) {
  function ErrorCatcher() {
    var _this;
    _classCallCheck(this, ErrorCatcher);
    _this = _callSuper(this, ErrorCatcher);
    _this.state = {
      hasError: false,
      formSubmitted: false,
      comments: ""
    };
    _this.submitReport = _this.submitReport.bind(_this);
    return _this;
  }
  _inherits(ErrorCatcher, _React$Component);
  return _createClass(ErrorCatcher, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error, info) {
      this.setState({
        error: error,
        info: info
      });
      Bole.error(error);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
        hasError = _this$state.hasError,
        formSubmitted = _this$state.formSubmitted;
      if (hasError && !formSubmitted) return this.renderForm();
      if (hasError && formSubmitted) return this.renderThankYou();
      return this.props.children;
    }
  }, {
    key: "renderForm",
    value: function renderForm() {
      var _this2 = this;
      return /*#__PURE__*/React.createElement("div", {
        className: styles$1.errorCatcher
      }, /*#__PURE__*/React.createElement("div", {
        className: styles$1.errorCatcherCard
      }, /*#__PURE__*/React.createElement(Icon, {
        className: styles$1.errorCatcherCardIcon,
        src: "haptik"
      }), /*#__PURE__*/React.createElement("div", {
        className: styles$1.errorCatcherCardTitle
      }, "Oops! Something went wrong."), /*#__PURE__*/React.createElement("div", {
        className: styles$1.errorCatcherCardSubtitle
      }, "Please fill out any details that might help us resolve this quickly"), /*#__PURE__*/React.createElement("div", {
        className: styles$1.errorCatcherCardAdvanced
      }), /*#__PURE__*/React.createElement("div", {
        className: styles$1.errorCatcherCardForm
      }, /*#__PURE__*/React.createElement(Text, {
        multiline: true,
        placeholder: "What lead to this crash? Any steps we might be able to use to recreate it?",
        className: styles$1.errorCatcherCardFormInput,
        value: this.state.comments,
        onChange: function onChange(comments) {
          _this2.setState({
            comments: comments
          });
        }
      })), /*#__PURE__*/React.createElement(Button, {
        onClick: this.submitReport,
        type: Button.TYPES.PRIMARY,
        className: styles$1.errorCatcherCardSubmit
      }, "Submit")));
    }
  }, {
    key: "renderThankYou",
    value: function renderThankYou() {
      return /*#__PURE__*/React.createElement("div", {
        className: styles$1.errorCatcher
      }, /*#__PURE__*/React.createElement("div", {
        className: styles$1.errorCatcherCard
      }, /*#__PURE__*/React.createElement(Icon, {
        className: styles$1.errorCatcherCardIcon,
        src: "tick-green"
      }), /*#__PURE__*/React.createElement("div", {
        className: styles$1.errorCatcherCardTitle
      }, "Crash Report Submitted"), /*#__PURE__*/React.createElement("div", {
        className: styles$1.errorCatcherCardSubtitle
      }, "We have recorded the details of the incident and are looking into it. ", /*#__PURE__*/React.createElement("br", null), "Thank you for your patience."), /*#__PURE__*/React.createElement(Button, {
        onClick: this.reload,
        primary: true,
        className: styles$1.errorCatcherCardSubmit
      }, "Reload")));
    }
  }, {
    key: "submitReport",
    value: function submitReport() {
      var _this3 = this;
      this.props.activateLoader();
      var _this$state2 = this.state,
        error = _this$state2.error,
        info = _this$state2.info,
        comments = _this$state2.comments;
      var report = {
        url: window.location.toString(),
        error: error.stack || error.message,
        info: info,
        comments: comments
      };
      fetch(this.props.url || "/admin_tools/report_crash", {
        method: "POST",
        body: JSON.stringify(report),
        headers: {
          "content-type": "application/json"
        }
      }).then(function (res) {
        return res.json();
      }).then(function () {
        _this3.props.deactivateLoader();
        _this3.setState({
          formSubmitted: true
        });
      });
    }
  }, {
    key: "reload",
    value: function reload() {
      window.location.reload();
    }
  }], [{
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError() {
      return {
        hasError: true
      };
    }
  }]);
}(React.Component);
ErrorCatcher.propTypes = {
  url: PropTypes.string,
  children: PropTypes.node,
  activateLoader: PropTypes.func,
  deactivateLoader: PropTypes.func
};
ErrorCatcher.defaultProps = {
  url: "",
  children: null,
  activateLoader: function activateLoader() {},
  deactivateLoader: function deactivateLoader() {}
};
ErrorCatcher.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "renderForm",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "renderThankYou",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "submitReport",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "reload",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }],
  "displayName": "ErrorCatcher",
  "props": {
    "url": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "children": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "node"
      },
      "required": false,
      "description": ""
    },
    "activateLoader": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "deactivateLoader": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    }
  }
};
var ErrorCatcher$1 = Loader({})(ErrorCatcher);

export default ErrorCatcher$1;
